export const PANEL = 0
export const CIRCUIT = 1
export const MCC = 2
export const MCC_COLUMN = 3
export const VFD = 4
export const BREAKER = 5
export const STARTER = 6
export const SOFTSTART = 7
export const AUXNODE = 8
export const SWITCHBOARD = 9
export const DISTRIBUTION_PANELBOARD = 10
export const TRANSFORMER = 11
export const DISCONNECT_SWITCH = 12
export const FUSE = 13
export const PANELBOARD_BREAKER = 14
export const MCC_BUCKET = 15
export const SWITCHBOARD_SECTION = 16
export const SWITCHBOARD_ITEM = 17

export default {
  PANEL,
  CIRCUIT,
  MCC,
  MCC_COLUMN,
  VFD,
  BREAKER,
  STARTER,
  SOFTSTART,
  AUXNODE,
  SWITCHBOARD,
  DISTRIBUTION_PANELBOARD,
  TRANSFORMER,
  DISCONNECT_SWITCH,
  FUSE,
  PANELBOARD_BREAKER,
  MCC_BUCKET,
  SWITCHBOARD_SECTION,
  SWITCHBOARD_ITEM,
  NODE_TYPE_MAP: {
    "panel": PANEL,
    "mcc": MCC,
    "vfd": VFD,
    "breaker": BREAKER,
    "starter": STARTER,
    "softstart": SOFTSTART,
    "auxnode": AUXNODE,
    "switchboard": SWITCHBOARD,
    "distributionPanelboard": DISTRIBUTION_PANELBOARD,
    "transformer": TRANSFORMER,
    "disconnectSwitch": DISCONNECT_SWITCH,
    "fuse": FUSE,
    "auxNode": AUXNODE,
  },
  node_types: [
    "panel",
    "mcc",
    "vfd",
    "breaker",
    "starter",
    "softstart",
    "auxnode",
    "switchboard",
    "distributionPanelboard",
    "transformer",
    "disconnectSwitch",
    "fuse"
  ],
  purchaseableNodeTypes: [
    "panels",
    "mccs",
    "vfds",
    "breakers",
    "starters",
    "softstarts",
    "distribution_panelboards",
    "switchboards",
    "transformers",
    "disconnect_switches",
    "fuses",
    "auxnodes"
  ],
  NODE_TYPE_STR_TO_INT: {
    panels: 0,
    circuits: 1,
    mccs: 2,
    mcc_columns: 3,
    vfds: 4,
    breakers: 5,
    starters: 6,
    softstarts: 7,
    auxnodes: 8,
    switchboards: 9,
    distribution_panelboards: 10,
    transformers: 11,
    disconnect_switches: 12,
    fuses: 13,
    panelboard_breakers: 14,
    mcc_buckets: 15,
    switchboard_sections: 16,
    switchboard_items: 17
  },
  NODE_LABELS_FOR_PATH_TYPE: {
    panels: "Panels",
    circuits: "Circuits",
    mccs: "MCCs",
    mcc_columns: "MCC Columns",
    vfds: "VFDs",
    breakers: "Breakers",
    starters: "Starters",
    softstarts: "Soft Starts",
    auxnodes: "Aux. Nodes",
    switchboards: "Switchboards",
    distribution_panelboards: "Distribution Panelboards",
    transformers: "Transformers",
    disconnect_switches: "Disconnect Switches",
    fuses: "Fuses",
    panelboard_breakers: "Panelboard Breakers",
    mcc_buckets: "MCC Buckets",
    switchboard_sections: "Switchboard Sections",
    switchboard_items: "Switchboard Items"
  },
  NODE_LABELS_FOR_INT_TYPE: {
    [PANEL]: "Panel",
    [CIRCUIT]: "Circuit",
    [MCC]: "MCC",
    [MCC_COLUMN]: "MCC Column",
    [VFD]: "VFD",
    [BREAKER]: "Breaker",
    [STARTER]: "Starter",
    [SOFTSTART]: "Soft Start",
    [AUXNODE]: "Aux. Node",
    [SWITCHBOARD]: "Switchboard",
    [DISTRIBUTION_PANELBOARD]: "Distribution Panelboard",
    [TRANSFORMER]: "Transformer",
    [DISCONNECT_SWITCH]: "Disconnect Switche",
    [FUSE]: "Fuse",
    [PANELBOARD_BREAKER]: "Panelboard Breaker",
    [MCC_BUCKET]: "MCC Bucket",
    [SWITCHBOARD_SECTION]: "Switchboard Section",
    [SWITCHBOARD_ITEM]: "Switchboard Item"
  },
  ORDER_NUM_BASE: 8324
};